import { render, staticRenderFns } from "./SamModal.vue?vue&type=template&id=15ac3252&scoped=true&"
import script from "./SamModal.vue?vue&type=script&lang=js&"
export * from "./SamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac3252",
  null
  
)

export default component.exports